<template lang="pug">
  .about
    header.header
      .left-section
        .logo_img(@click="sectionTrans(0)")
        span.logoName(@click="sectionTrans(0)") {{title}}
      a.right-section(:href="`mailto:${email}`")
        span Contact us via {{email}}
    ul.nav_r(role="nav",v-if="!isMobile")
      li(v-for="i in sNum", @click="sectionTrans(i-1)",:class="{active:navClass[i-1]}")
        a
    section(v-for='i in sNum',:style="isMobile?'':{height:sectionHeight +'px',transform:`translate3d(0px,${y}px, 0px)`}",:class="[sClass[i-1],{transform:bTrans}]")
      .main
        div(:style="isMobile?'':{transform:`translate3d(0px,${-y -sectionHeight *(i-1)}px, 0px)`}",:class="{content:'true',transform:bTrans}")
          .left
            img.show(:src="img['p'+i]")
          right(:title='titles[i-1]', :explain='explains[i-1]', :downloadUrl="downloadUrl")
      .footWrapper(v-if="i===3 && needFooter")
        foot
</template>

<script>
import right from '@/components/Content.vue'
import foot from '@/components/FootPC.vue'
import { isMobile } from './utils/index'
import p1 from '@/assets/p1.png'
import p2 from '@/assets/p2.png'
import p3 from '@/assets/p3.png'

export default {
  data() {
    return {
      index: 0, // 当前页面的index
      y: 0, // 控制滚动
      ticking: false, // 优化动画
      sectionHeight: 0,
      sNum: 3,
      btnNum: 3,
      tStart: null,
      navClass: [true, false, false, false],
      sClass: ['sw', 'sr', 'sw'],
      bTrans: false,
      isMobile: false,
      img: {
        p1,
        p2,
        p3,
      },
      detail: 0,
      timeId: null,
      canGo: true,
      title: 'JamUp',
      email: 'jamup.service@gmail.com',
      downloadUrl: 'https://apps.apple.com/app/id6448248622',
      titles: [
        'JamUp - Chords & Multi-Tracks',
        'JamUp - Chords & Multi-Tracks',
        'JamUp - Chords & Multi-Tracks',
      ],
      explains: [
        'Learn a new song in 3 minutes.',
        'Unlimited access to thousands of chords.',
        'An easy to use interactive player.',
      ],
      needFooter: false,
    }
  },
  created() {
    document.title = this.title
  },
  /* eslint-disable */
   mounted() {
     this.setFontSize()
     this.sectionHeight = window.innerHeight
     function bindEvent(doms, action, callback) {
       for (let i = 0; i < doms.length; i++) {
         doms[i].addEventListener(action, (function (i) {
           return callback.bind(null, i)
         }(i)))
       }
     }
     const sections = document.getElementsByTagName('section')
     bindEvent(sections, 'transitionend', () => {
       this.bTrans = false
     })

     // 滚动

     if(!isMobile()) {
       setTimeout(() => {
         window.scrollTo(0, 0)
         document.addEventListener('mousewheel', this.debounce)
         document.addEventListener('DOMMouseScroll', this.debounce)
         window.addEventListener('resize', this.resize)
         window.addEventListener('unload', () => {
           console.log('remove')
           window.removeEventListener('resize', this.resize)
           document.removeEventListener('mousewheel', this.debounce)
           document.removeEventListener('DOMMouseScroll', this.debounce)
         })
       }, 500)
     }

   },
   methods: {
     debounce(e) {
        const tCurr = +new Date();

        if (!this.tStart) {
          this.tStart = tCurr;
        }
        clearTimeout(this.timeId)
        const detail = e.wheelDelta || -e.detail
        // console.log('scroll', tCurr - this.testTime)
        if (this.canGo) {
          this.canGo = false
          this.scroll(detail, tCurr)
         }
        const canGoInterval = /firefox/i.test(navigator.userAgent) ? 100 : 50
        this.timeId = setTimeout(() => {
          this.canGo = true
        }, canGoInterval)
     },
     scroll(detail, tCurr) {
       const interval = 100

       const timeAllowed = tCurr - this.tStart >= interval || tCurr === this.tStart
       const otherDirection = this.detail * detail < 0
       // console.log('trans', tCurr - this.tStart)

       // const speedAllowed = Math.abs(detail) >= Math.abs(this.detail)
       // console.log(tCurr - this.tStart)

       const canGo = timeAllowed || otherDirection
       if (canGo && !this.bTrans){
         const delta = Math.max(-1, Math.min(1, detail));
         const i = this.index - delta
         this.sectionTrans(i)
       }
       this.detail = detail
       this.tStart = tCurr
     },
     resize() {
       const screenHeight = window.innerHeight
       this.setFontSize()
       // this.y = parseInt(this.index * screenHeight, 10)
       this.sectionHeight = screenHeight
       // console.log('y:',this.y,'index:',this.index)
       this.sectionTrans(this.index)
     },
     navActive(i) {
       this.navClass.forEach((item, index, array) => {
         array[index] = (index === i)
       })
     },
     sectionTrans(i) {
       if(this.isMobile) {
         this.index = 0
         this.y =0
         return
       }
       if(i>= this.sNum || i<0) return
       this.navActive(i)
       if(i===0) {
         document.body.scrollTop = 0
         document.documentElement.scrollTop =0
       }
       const height = this.sectionHeight
       this.y = -i * height
       this.bTrans = true

       this.index = i
     },
     setFontSize() {
       const html = document.querySelector('html')
       if (window.screen && window.innerWidth) {
         const screenWidth = window.innerWidth
         const screenHeight = window.innerHeight
         // console.log(screenWidth , screenHeight)
         this.isMobile = false
         if (screenWidth > 1800) {
           html.style.fontSize = '56px'
         } else if (screenWidth > 1500 && screenHeight > 830) {
           html.style.fontSize = '58px'
         } else if (screenWidth <= 620) {
           const fz = 26
           html.style.fontSize = `${fz}px`
           this.isMobile = true
           var realfz = +window.getComputedStyle(html).fontSize.replace('px','')
           if (realfz !== fz) {
             html.style.cssText = 'font-size: ' + fz * (fz / realfz) +"px";
           }
         } else if (screenWidth < 700 || screenHeight < 700) {
           html.style.fontSize = '40px'
         } else {
           html.style.fontSize = '48px'
         }
         const pDom = document.querySelectorAll('.right p')
         if (screenWidth > 1800) {
           Array.from(pDom, x => x.className = `${x.className} large`)
         } else {
           Array.from(pDom, x => x.className = x.className.split(' large').join(''))
         }
       }
     },
   },
   components: {
     foot,
     right
   },
    beforeDestroy() {
     window.removeEventListener('resize', this.resize)
     document.removeEventListener('mousewheel', this.debounce)
     document.removeEventListener('DOMMouseScroll', this.debounce)
   }
 }

</script>

<style lang="stylus">
  html,body
    overflow:hidden
    font-family: Roboto-light
  html,body,h2,h3,p,ul,li,a
    margin: 0
    padding:0
  a, a:active
    cursor: pointer
    text-decoration: none
    color: #434343
  /*头部*/
  header
    position:fixed;
    height: 1.04rem;
    width: 100%;
    font-family: Roboto-regular;
    font-size: 0.375rem;
    line-height:1.04rem;
    box-shadow: 4px 0 12px rgba(0,0,0,0.3);
    background-color: #fff;
    z-index: 3;
    cursor:pointer;
  .logo_img
    background: url(./assets/logo.png);
    display: inline-block;
    height: 0.8rem;
    width: @height;
    line-height: @height;
    background-size: contain;
    margin:auto 0.089rem auto 1.1458rem;
    vertical-align:middle;
    cursor:pointer;
  .logo_img:after
    content: '';
    height: 100%;
    margin-left: -0.25rem; /* To offset spacing. May vary by font */
  /*右侧切换条，加r是为了foot里也有nav*/
  .nav_r
    position:fixed;
    width: 1.2917rem;
    height:100px;
    right:0;
    top:calc(50% - 50px);
    z-index:2;
    cursor:pointer;
    li
      width:100%;
      list-style: none;
      padding:6px 0;
      cursor: pointer;
      a
        display: block;
        height:8px;
        width:8px;
        border-radius:50%;
        background-color: rgba(65,65,65,.3);
        cursor:pointer;
        &:hover
          background-color: rgba(65,65,65,.7);
    .active a
      background-color: #000;
  /*主体*/
  .transform
    transition: transform 0.5s linear;
  section
    position: relative;
    overflow:hidden;
    width: 100%;
    height: 100vh;
    background: #fff;
  .main
    margin-top:1.25rem;
    width: calc(100% - 1.3333rem);
  .content
    position: absolute;
    left:calc(50% - 7.6rem);
    top:calc( 50% - 5.4rem);
    bottom:0;
    z-index:1;
    height:10.6667rem;
    width:15.2rem;
  .left
    float:left;
    height:10.6666rem;
    width:5.2082rem;
    position:relative;
  .show
    width: 100%;
    max-height:100%;
    max-width: 100%;
  .right
    float:right;
    height:7.2917rem;
    width:7.8rem;
    margin-top: 0.7rem;
    h2
      font-size: 0.8333rem;
      font-weight: 600;
      line-height:1rem;
      color:#4791ff;
    p
      font-size:18px;
      color:#333333;
      line-height: 22px;
    p.large
      font-size:20px;

    strong
      font-weight:bold;
  .explain
    margin-top:24px;
  .img_wrap
    margin-top: 1.167rem;
    .p
      display:inline-block;
      height:0.8333rem;
      width:2.8333rem;
      background-size: 100% 100%;
      background-repeat:no-repeat;
      margin-right:0.4167rem;
  .img1
    background:url(./assets/button_logo.png) ;

  /*第2部分*/
  .sr
    background: #4791ff;
    .right
      h2, h3
        color:#fff;
      h3
        font-size:20px;
        font-weight: normal;
      p
        color:#fff;
  .footWrapper
    position:absolute;
    padding-bottom:20px;
    background :#FAFAFA;
    border-top:1px solid #EBEBEB;
    width: 100%;
    text-align: center;
    bottom:0;
    left: 0;
    font-size: 0.24rem;
  .header
    display: flex;
    justify-content: space-between;
    align-items: center;
  .left-section
    width 50%
    min-width 160px
  .right-section
    font-size 0.8em
    display block
    line-height 15px
    background url('~@/assets/contact_icon-email.png') 100% 50% / 15px 15px no-repeat
    padding-right 20px
    margin-right 20px
    text-align right
  @media screen and (max-width: 620px)
    html,body
      overflow: scroll;
    .s2 .right .choice
      margin-top: 15px
    .sr .btn
      height: 40px;
      width: 40px;
    .content
      left: 0;
      width: 100%;
    .left
      margin-left:15px;
    .right
      float: left;
      width: calc(100% - 185px);
      max-width: 300px;
      margin:-15px auto auto 20px;
      .explain
        font-size: 0.6rem
        line-height: 1.25
    header
      height: 50px;
    .logo_img
      display: inline-block;
      height: 50px;
      width: 50px;
      line-height: 0.98rem;
      background-size: contain;
      margin:auto 2px auto 0;
    .s3
      .content
        top: 0.5rem
      .left
        margin-left: 0
        .show
          left: 50%
          margin-left: -4rem
      .right
        margin: 0 auto
        width: 90%
        float: none
        h2
          text-align: center
    .img_wrap .p
      height:1rem;
      width:3.2rem;
  @media screen and (max-width: 340px)
    .right
      h2
        line-height: 1.25
        font-size: 0.7rem
      .explain
        font-size: 0.46rem
        line-height: 1.25
    .s3
      .explain
        margin-top: 0.4rem
      .left .show
        width: 6rem
        height: auto

</style>
